<template>
  <a-modal
    title="科室详情"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    v-if="hackReset"
    @cancel="handleCancel"
  >
  <template slot="footer">
    <a-button key="back" @click="handleCancel">
      取消
    </a-button>
    <a-button key="cancel" @click="handleEdit"  :loading="btnEdit">
      保存
    </a-button>
    <a-button key="submit" type="primary" @click="handleDelete" :loading="btnDelete">
      删除
    </a-button>
  </template>
        <div class="viewDetial-tiem">
          <a-form layout="inline">
              <a-row>
                  <a-col>
                      <a-form-item label="医院">
                          <!-- <a-input v-model="queryParam.status" allow-clear placeholder="请输入状态"/> -->
                          <a-select  style="width:200px" v-model="queryParam.orgId"  allow-clear placeholder="请选择医院" :options="recipeStatus"></a-select>
                      </a-form-item>
                  </a-col>
              </a-row>
              <a-row>
                  <a-col>
                    <a-form-item label="上级科室">
                        <a-tree-select
                          v-model="queryParam.parentId"
                          style="width: 200px"
                          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                          :tree-data="parentOptions"
                          placeholder="请先选择医院"
                        >
                          <!-- <span slot="title" slot-scope="{ key, value }" style="color: #08c">
                            Child Node1 {{key }} {{  value }}
                          </span> -->
                        </a-tree-select>
                    </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                  <a-col>
                      <a-form-item label="科室名称">
                          <a-input v-model="queryParam.deptName" allow-clear placeholder="请输入科室名称"/>
                      </a-form-item>
                  </a-col>
              </a-row>
              <a-row>
                  <a-col>
                      <a-form-item label="科室负责人">
                          <a-input v-model="queryParam.linkman" allow-clear placeholder="请输入科室负责人"/>
                      </a-form-item>
                  </a-col>
              </a-row>
              <a-row>
                  <a-col>
                      <a-form-item label="负责人电话">
                          <a-input v-model="queryParam.phone" allow-clear placeholder="请输入负责人电话"/>
                      </a-form-item>
                  </a-col>
              </a-row>
              <a-row>
                  <a-col>
                      <a-form-item label="科室位置">
                          <a-input v-model="queryParam.position" allow-clear placeholder="请输入科室位置"/>
                      </a-form-item>
                  </a-col>
              </a-row>
              <!-- <a-row>
                  <a-col>
                      <a-form-item label="科室类型">
                          <a-radio-group v-model="queryParam.radio" name="radioGroup">
                              <a-radio value="1">互联网医院科室</a-radio>
                              <a-radio value="2">门诊科室</a-radio>
                          </a-radio-group>
                      </a-form-item>
                  </a-col>
              </a-row> -->
              <a-row>
                  <a-col>
                      <a-form-item label="科室描述">
                          <a-input v-model="queryParam.deptName" allow-clear placeholder="请输入科室描述"/>
                      </a-form-item>
                  </a-col>
              </a-row>
              <a-row>
                  <a-col>
                    <a-form-item label="监管对应诊疗科目名称">
                        <a-select  style="width:200px" v-model="queryParam.deptClassCode" placeholder="请选择监管对应诊疗科目名称" :options="classOption"></a-select>
                    </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                  <a-col>
                      <a-form-item label="状态">
                          <a-radio-group v-model="queryParam.useflag" name="status">
                              <a-radio value="1">正常</a-radio>
                              <a-radio value="2">停用</a-radio>
                          </a-radio-group>
                      </a-form-item>
                  </a-col>
              </a-row>
          </a-form>
    </div>
    
    
  </a-modal>
</template>

<script>
  import { STable } from '@/components';
  import moment from 'moment'
  import { getDepartment , inquiryorderSelect , editDepartment , removeDepartment , getClassDepartment , getParentDepartment } from '@/api/modular/interhospital/hlwyyDepartment/hlwyyDepartmentManage'
  export default {
    components:{
      STable
    },
    data () {
      return {
        queryParam : {},
        visible: false,
        hackReset : true,
        kg : '',
       
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        verifytimeDateString: '',
        
        confirmLoading: false,
        btnEdit : false,
        btnDelete : false,
        recipeStatus : [],
        deptId : '',
        parentOptions : [],
        classOption : [],
      }
    },
    created(){
      this.loadUser = [];
    },
    methods: {
      moment,
      // 初始化方法
      add (record) {
        this.visible = true;
        this.deptId = record.deptId;
        this.getSelecte();
        this.getClass();
        this.getList(record.deptId)
      },
      // 获取医院下拉框
      async getSelecte(){
        await inquiryorderSelect().then(res=>{
          this.recipeStatus = [];
          res.data.map((item,index)=>{
            this.recipeStatus.push({
              label : item.orgName,
              value : item.orgId
            })
          })
        })
      },
      // 查看列表数据
      async getList(deptId){
        await getDepartment(deptId).then(res=>{
          this.queryParam = res.data;
          this.queryParam.parentId = res.data.parentId == 0 ? '' : res.data.parentId;
          this.queryParam.useflag = this.queryParam.useflag + '';
          // console.log(this.queryParam)
          this.getParentList(res.data.orgId)
        })
        
      },
      // 获取科目
      async getClass(){
        this.classOption = [];
        await getClassDepartment().then(res=>{
          // console.log(res.code);
          if(res.code == 200){
            res.data.map((item,index)=>{
              this.classOption.push({
                label : item.detailName,
                value : item.detailValue,
              })
            })
          }else{
            this.classOption = [];
          }
        })
      },
      // 获取父级科室
      async getParentList(orgId){
          let params = {
            orgId ,
          }
          this.parentOptions = [];
          await getParentDepartment(params).then(res=>{
            // console.log(res)
            if(res.code == 200){
              this.parentOptions =  this.recursion(res.data);
              // console.log( '父级科室', this.parentOptions)
            }
          })
      },
      recursion(arr){
        arr.forEach((item,index)=>{
          if(item.childDepartments instanceof Array){
              arr[index] = {
                title : item.deptName,
                value : item.deptId,
                key : item.deptId,
                children :  item.childDepartments
              }
              this.recursion(item.childDepartments)
          }else{
            arr[index] = {
              title : item.deptName,
              value : item.deptId,
              key : item.deptId,
              children :  []
            }
          }
          
        })
        return arr
      },

      //点击取消按钮
      handleCancel () {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
        })
      },

      // 点击编辑按钮
      handleEdit(){
        this.btnEdit = true;
        editDepartment(this.queryParam).then(res=>{
          // console.log(res)
          this.btnEdit = false;
          if(res.code == 200){
            this.$message.success('修改成功');
            this.visible = false;
            this.hackReset = false;
            this.$nextTick(()=>{
              this.hackReset = true;
            })
            this.$parent.handleOk();
          }
        })
      },

      // 点击删除按钮
      handleDelete(){
        this.btnDelete = true;
        removeDepartment(this.deptId).then(res=>{
          this.btnDelete = false;
          if(res.code == 200){
            this.$message.success('操作成功');
            this.visible = false;
            this.hackReset = false;
            this.$nextTick(()=>{
              this.hackReset = true;
            })
            this.$parent.handleOk();
          }
        })
      }
    },
  }
</script>
<style lang="less" scoped>
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
}
/deep/.s-table-tool{
  display: none;
}
.totalPrice{
  line-height: 30px;
  padding: 0 30px;
}
.detialImage{
  width: 80px;
  height: 30px;
  margin: 0 10px;
  cursor: pointer;
  
  // transform: rotate();
}
/deep/.ant-col .ant-form-item-label{
    width: 155px;
}
</style>
